import { OrgTrainingScheduleAssignment } from "./OrgTrainingSchedule.schema";

export type OrgTrainingScheduleOverrideId = string;

/**
 * Per-date override for an OrgTrainingSchedule. Each document represents exceptions
 * (cancellations, reassignments, one-off sessions) for a single date.
 *
 * Split out into its own collection so we don't hit Firestore's 1MB document limit
 * on the main schedule as overrides accumulate over a long season.
 *
 * ID format: `{scheduleId}_{dateString}` (deterministic — enables direct lookup without queries).
 */
export interface OrgTrainingScheduleOverride {
  id: OrgTrainingScheduleOverrideId;
  scheduleId: string;
  orgId: string;
  dateString: string; // "YYYY-MM-DD"

  canceled?: boolean;
  closedFieldIds?: string[]; // Fields closed on this date (all slots on these fields treated as canceled)
  fieldOverrides?: {
    [orgFieldId: string]: {
      [slotKey: string]: {
        canceled?: boolean;
        assignments?: OrgTrainingScheduleAssignment[];
        startTime?: string; // "HH:mm" — for one-off override slots not in template
        endTime?: string; // "HH:mm" — for one-off override slots not in template
      };
    };
  };

  createdAtMS: number;
  updatedAtMS: number;
}

export function computeOverrideDocId(scheduleId: string, dateString: string): string {
  return `${scheduleId}_${dateString}`;
}
